<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Exporte</h5>
        </div>
        <div class="form-group row">
            <div v-for="item, key in items" class="col-md-3">
                <div><label class="control-label"> {{item.label}} </label></div>
                <datepicker  v-if="item.type==='date'" v-model="item.value" language="es" v-on:input="updateDate" :name="item.name" :inputClass="item.class" :wrapperClass="item.divclass" :placeholder="item.placeholder" format="YYYY-MM-DD H:i:s" :disabled="item.disabled"></datepicker>
                <div v-if="item.type==='date'"  v-for="error in item.errors" style="margin-left: 18px" id="errors" v-model="item.errors">
                    <div class="clearfix"></div>
                    {{ error }}
                    <div class="clearfix"><br></div>
                </div>
            </div>
            <div class="clearfix"></div>
            <br>
            <div class="col-md-12 text-left">
                <input type="button" class="btn btn-success" value="Exportar" name="Guardar" v-on:click="exportpqr">
            </div>
        </div>   
    </div>
</template>


<script>
import Datepicker from 'vuejs-datetimepicker'
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import swal from 'sweetalert2'

export default{
    name: 'emt-form-export',
    data: function () {
        return {
            items: [
                {
                    'name': 'date_start',
                    'label': 'Fecha inicio',
                    'class': 'form-control txb-calendar',
                    'divclass': 'col-md-3',
                    'placeholder': 'Ingrese fecha inicio',
                    'value': null,
                    'maxlength': '50',
                    'type': 'date',
                    'errors': []
                }, {
                    'name': 'date_end',
                    'label': 'Fecha Fin',
                    'class': 'form-control txb-calendar',
                    'divclass': 'col-md-3',
                    'placeholder': 'Ingrese fecha fin',
                    'value': null,
                    'maxlength': '50',
                    'type': 'date',
                    'errors': []
                }
            ],
            config: Config,
            update: false
        }
    },
    methods: {
        getFormValues: function () {
            var self = this
            var formValues = {}
            for (var i = 0; i < self.items.length; i++) {
                formValues[self.items[i].name] = self.items[i].value !== null ? self.items[i].value : null
            }
            return formValues
        },
        updateDate: function (value) {
            for (var item in this.items) {
                try {
                    this.items[item].value = this.items[item].value
                } catch (e) {}
                // this.items[item].value = value
            }
        },
        exportpqr: function () {
            var values = this.getFormValues()
            if (values['date_end'] === null || values['date_start'] === null) {
                for (var item in this.items) {
                    if (this.items[item].name === 'date_start' && this.items[item].value === null) {
                        this.items[item].errors = ['Debe seleccionar la fecha inicio']
                    }
                    if (this.items[item].name === 'date_end' && this.items[item].value === null) {
                        this.items[item].errors = ['Debe seleccionar la fecha fin']
                    }
                }
                return
            }
            var dateEnd = new Date(values['date_end'])
            var dateStart = new Date(values['date_start'])
            if (dateStart > dateEnd) {
                this.items[0].errors = []
                this.items[1].errors = []
                for (var j in this.items) {
                    if (this.items[j].name === 'date_end') {
                        this.items[j].errors = ['La fecha fin no debe ser menor a la fecha de inicio']
                    }
                }
                return
            }
            // var dateDiff = dateStart - dateEnd
            var oneDay = 1000 * 60 * 60 * 24
            // Convert both dates to milliseconds
            var dateDStart = dateStart.getTime()
            var dateDEnd = dateEnd.getTime()
            // Calculate the difference in milliseconds
            var differenceDates = Math.abs(dateDStart - dateDEnd)
            if ((Math.round(differenceDates / oneDay)) > 31) {
                swal({
                    title: '',
                    text: 'El rango de fecha no puede superar los 31 días.',
                    type: 'error',
                    confirmButtonText: 'Aceptar'
                })
                return
            }
            this.$http.post(Config.api + '/export/', values, {responseType: 'arraybuffer'}).then(function (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Pqrs.xls')
                document.body.appendChild(link)
                link.click()
                this.items[0].errors = []
                this.items[1].errors = []
            }, function (response) {
                swal({
                    title: '',
                    text: response.body.error,
                    type: 'error',
                    confirmButtonText: 'Aceptar'
                })
                let date = new Date(Date.now())
                this.items[0].value = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate() + ' 00:00:00'
                this.items[1].value = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate() + ' 23:59:59'
                this.items[0].errors = []
                this.items[1].errors = []
            })
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        let date = new Date(Date.now())
        this.items[0].value = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate() + ' 00:00:00'
        this.items[1].value = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate() + ' 23:59:59'
        generic.setToken()
    },
    components: {
        'datepicker': Datepicker
    }
}
</script>
<style scoped>
.vdp-datepicker.col-md-3 {
    width: 100% !important;
}
.control-label {
    margin-left: 15px;
    margin-top: 15px
}
.btn-success {
    margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// emt-form-export.vue?78964594